import { createFileRoute } from "@tanstack/react-router"
import { ReplaceVaultEntry } from "modules/settings/components/KeysAndSecrets/ReplaceVaultEntry"

export const Route = createFileRoute("/_base/_auth/settings/keys-and-secrets/vault/$key/replace")({
  component: ReplaceVaultEntry,
})
